(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/components/app.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/components/app.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$tt$components = svs.tt.components,
  Filter = _svs$tt$components.Filter,
  Matchlist = _svs$tt$components.Matchlist,
  Navigation = _svs$tt$components.Navigation;
const _svs$tt$hooks = svs.tt.hooks,
  useDraws = _svs$tt$hooks.useDraws,
  useSportFilter = _svs$tt$hooks.useSportFilter;
const baseUrl = svs.core.data.baseUrl || '';
const settings = svs.tt.productSettings;
const parseProductKey = () => {
  const matchlistIndex = window.location.pathname.indexOf('/matchlist');
  if (matchlistIndex === -1) {
    return null;
  }
  const rest = window.location.pathname.slice(matchlistIndex + '/matchlist'.length);
  if (!rest || rest === '/') {
    return null;
  }
  return rest.replace(/^\//, '').replace(/\/.*$/, '') || null;
};
const buildMatchlistUrl = productKey => {
  const suffix = productKey ? "matchlist/".concat(productKey) : 'matchlist';
  return baseUrl.endsWith('/') ? "".concat(baseUrl).concat(suffix) : "".concat(baseUrl, "/").concat(suffix);
};
const resolveProductSetting = productKey => {
  if (productKey && settings[productKey]) {
    return {
      key: productKey,
      setting: settings[productKey]
    };
  }
  const fallback = svs.tt.defaultProduct;
  return {
    key: fallback,
    setting: settings[fallback]
  };
};
const App = () => {
  const _useState = useState(() => {
      const initial = parseProductKey();
      return resolveProductSetting(initial).key;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    productKey = _useState2[0],
    setProductKey = _useState2[1];
  useEffect(() => {
    const onPopState = () => {
      const next = resolveProductSetting(parseProductKey()).key;
      setProductKey(next);
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);
  const _resolveProductSettin = resolveProductSetting(productKey),
    productSetting = _resolveProductSettin.setting;
  const _useDraws = useDraws(productSetting),
    draws = _useDraws.draws,
    availableSports = _useDraws.availableSports,
    loading = _useDraws.loading;
  const _useSportFilter = useSportFilter(productSetting),
    filters = _useSportFilter.filters,
    toggleSport = _useSportFilter.toggleSport,
    isVisible = _useSportFilter.isVisible;
  const onSelect = useCallback(nextKey => {
    if (!svs.tt.productSettings[nextKey] || nextKey === productKey) {
      return;
    }
    window.history.pushState({}, '', buildMatchlistUrl(nextKey));
    setProductKey(nextKey);
  }, [productKey]);
  const showMatchlist = !loading && productSetting && productSetting.productType !== 'start';
  return React.createElement("div", {
    className: "tt-container"
  }, React.createElement("div", {
    className: "tt-sidebar"
  }, React.createElement("div", {
    className: "tt-navigation"
  }, React.createElement(Navigation, {
    activeKey: productKey,
    onSelect: onSelect,
    productSettings: svs.tt.productSettings
  })), React.createElement("div", {
    className: "tt-filter"
  }, React.createElement(Filter, {
    availableSports: availableSports,
    filters: filters,
    onToggleSport: toggleSport,
    productSetting: productSetting
  }))), React.createElement("main", {
    "aria-labelledby": "main-heading",
    className: "tt-main"
  }, loading && React.createElement("p", {
    className: "padding-1"
  }, "Laddar..."), showMatchlist && React.createElement(Matchlist, {
    draws: draws,
    isVisible: isVisible,
    productSetting: productSetting
  })));
};
setGlobal('svs.tt.components.App', App);

 })(window);